export * from './WhatsNewDetailIFrame';
